<script>
    import { Bar } from "vue-chartjs";
    export default {
        extends: Bar,
        methods: {
            loadData: function (labeldata, setdata, capas_seleccionada) {
                const self = this;
                self.renderChart(
                        {
                            labels: labeldata,
                            datasets: [
                                {
                                    label: capas_seleccionada,
                                    backgroundColor: "#1a8016",
                                    data: setdata
                                }
                            ]
                        },
                        { responsive: true, maintainAspectRatio: true }
                    );
                 }
        }

    };
</script>